import React from 'react'

import { useStyles } from './summary-block.style'

/**
 * Summary block is a specially formatted block of text
 * If no text is passed in, it will pull the description from the report
 */
export const SummaryBlock = function ({ report, text }) {
  const classes = useStyles()
  text = text || report.description
  return (
    <div className="flex-row flex-center-items">
      <div className={classes.summary}>{text}</div>
    </div>
  )
}
